export const REQUEST = "REQUEST";
export const FAILURE = "FAILURE";
export const OTP_REQUEST_SUCCESS = "OTP_REQUEST_SUCCESS";
export const MOBILE_OTP_REQUEST_SUCCESS = "MOBILE_OTP_REQUEST_SUCCESS";
export const VERIFY_OTP_REQUEST_SUCCESS = "VERIFY_OTP_REQUEST_SUCCESS";
export const VERIFY_MOBILE_OTP_REQUEST_SUCCESS =
  "VERIFY_MOBILE_OTP_REQUEST_SUCCESS";
export const GET_USER_TYPES = "GET_USER_TYPES";
export const USER_CREATE = "USER_CREATE";
export const UPDATE_USER_TYPE = "UPDATE_USER_TYPE";
export const INSTITUITON_LIST_SUCCESS = "INSTITUITON_LIST_SUCCESS";
export const INSTITUITON_USER_TYPE_LIST_SUCCESS =
  "INSTITUITON_USER_TYPE_LIST_SUCCESS";
export const UPDATE_USER_FORM_VALUES = "UPDATE_USER_FORM_VALUES";
export const UPDATE_FROM_DETAILS = "UPDATE_FROM_DETAILS";
export const USER_FORM_ERRROS = "USER_FORM_ERRROS";
export const CLEAR_USER_ERROR_OBJ="CLEAR_USER_ERROR_OBJ";
export const UPLOAD_USER_IMAGE = "UPLOAD_USER_IMAGE";
export const STATE_LIST_OPTIONS_REQUEST = "STATE_LIST_OPTIONS_REQUEST";
export const STATE_LIST_OPTIONS_SUCCESS = "STATE_LIST_OPTIONS_SUCCESS";
export const STATE_LIST_OPTIONS_FAILURE = "STATE_LIST_OPTIONS_FAILURE";

export const DISTRICT_LIST_OPTIONS_REQUEST = "DISTRICT_LIST_OPTIONS_REQUEST";
export const DISTRICT_LIST_OPTIONS_SUCCESS = "DISTRICT_LIST_OPTIONS_SUCCESS";
export const DISTRICT_LIST_OPTIONS_FAILURE = "DISTRICT_LIST_OPTIONS_FAILURE";
export const SPORT_LIST_AND_KIT_LIST = "SPORT_LIST_AND_KIT_LIST";

export const FETCHED_USER_DETAILS = "FETCHED_USER_DETAILS";

export const CHANGE_HIDE_STATUS = "CHANGE_HIDE_STATUS";

export const REGISTRATION_LISTING = "REGISTRATION_LISTING";
export const CORRECTION_DATA = "CORRECTION_DATA";
export const LOGIN_USER = "LOGIN_USER";
export const FETCH_OTHERS_SUBCATEGORY = "FETCH_OTHERS_SUBCATEGORY";

// forgot password
export const FORGOT_PASSWORD_SENT_REQUEST_FOR_OTP_REQUEST =
  "FORGOT_PASSWORD_SENT_REQUEST_FOR_OTP_REQUEST";
export const FORGOT_PASSWORD_OTP_REQUEST_SUCCESS =
  "FORGOT_PASSWORD_OTP_REQUEST_SUCCESS";
export const FORGOT_PASSWORD_OTP_REQUEST_FAILURE =
  "FORGOT_PASSWORD_OTP_REQUEST_FAILURE";

// otp verification of forgot password
export const OTP_VERIFY_REQUEST_OF_FORGOT_PASS =
  "OTP_VERIFY_REQUEST_OF_FORGOT_PASS";
export const OTP_VERIFY_SUCCESS_OF_FORGOT_PASS =
  "OTP_VERIFY_SUCCESS_OF_FORGOT_PASS";
export const OTP_VERIFY_FAILURE_OF_FORGOT_PASS =
  "OTP_VERIFY_FAILURE_OF_FORGOT_PASS";

export const DELETE_REGISTRATION_DOC_SUCCESS =
  "DELETE_REGISTRATION_DOC_SUCCESS";
